import HeroCTA from '../components/HeroCTA'
import TrustBadges from '../components/TrustBadges'
import StructuredData from '../components/StructuredData'
import './FacilitiesManagersLandingPage.css'

function FacilitiesManagersLandingPage() {
  const structuredData = {
    '@context': 'https://schema.org',
    '@type': 'Service',
    name: 'Lab Renovation Support for Facilities Managers',
    description: 'Lab renovation, safety compliance, and efficiency optimization for facilities managers',
    provider: {
      '@type': 'LocalBusiness',
      name: 'Laboratory Specialists'
    },
    areaServed: {
      '@type': 'Country',
      name: 'United States'
    }
  }

  return (
    <div className="fm-landing-page">
      <StructuredData data={structuredData} />

      {/* Hero Section */}
      <section className="fm-hero-section">
        <div className="container">
          <div className="fm-hero-content">
            <h1 className="fm-hero-title">
              Renovating an Old Lab?
              <span className="fm-hero-accent">We Help Facilities Managers Get It Right</span>
            </h1>
            <p className="fm-hero-subtitle">
              From safety compliance to efficiency optimization, we partner with facilities managers 
              to renovate labs that meet standards, reduce operating costs, and support your operations for years to come.
            </p>
            <div className="fm-hero-cta-wrapper">
              <HeroCTA text="Get Your Free Renovation Consultation" variant="accent" />
              <p className="fm-hero-trust-text">
                ✓ Free Consultation • ✓ No Obligation • ✓ 35+ Years Lab Expertise
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Services Section - What We Help With */}
      <section className="fm-services-section">
        <div className="container">
          <h2 className="fm-section-title">Everything You Need for a Successful Lab Renovation</h2>
          <p className="fm-section-subtitle">
            We help facilities managers navigate lab renovations—ensuring safety, efficiency, 
            and long-term cost savings.
          </p>

          <div className="fm-services-grid">
            <div className="fm-service-card">
              <div className="fm-service-icon">🏗️</div>
              <h3>Lab Renovation Planning</h3>
              <p>
                We help you plan and execute lab renovations—from outdated facilities to modern, 
                compliant spaces. Our team coordinates equipment upgrades, casework replacement, 
                and infrastructure improvements.
              </p>
            </div>
            <div className="fm-service-card">
              <div className="fm-service-icon">🛡️</div>
              <h3>Safety Standards & Compliance</h3>
              <p>
                Ensure your renovated lab meets all safety standards and regulatory requirements. 
                We offer safety audits, compliance reviews, and guidance on fume hoods, eyewash stations, 
                and other critical safety equipment.
              </p>
            </div>
            <div className="fm-service-card">
              <div className="fm-service-icon">📉</div>
              <h3>Efficiency Audits to Reduce Operating Costs</h3>
              <p>
                Our efficiency audits identify opportunities to reduce operating costs—from 
                equipment optimization to workflow improvements. We've saved over a million dollars 
                in operating expenses on a single project.
              </p>
            </div>
            <div className="fm-service-card">
              <div className="fm-service-icon">📋</div>
              <h3>Project Management for Facilities Managers</h3>
              <p>
                Dedicated project management support to coordinate renovations, track timelines, 
                and ensure smooth execution—so you can focus on your broader facilities responsibilities.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Why Partner With Us */}
      <section className="fm-why-section">
        <div className="container">
          <h2 className="fm-section-title">Why Facilities Managers Partner With Us</h2>
          <div className="fm-why-grid">
            <div className="fm-why-item">
              <h4>Safety First</h4>
              <p>We ensure your renovated lab meets OSHA, fire safety, and lab-specific compliance requirements.</p>
            </div>
            <div className="fm-why-item">
              <h4>Reduce Operating Costs</h4>
              <p>Efficiency audits and smart equipment choices help lower ongoing expenses.</p>
            </div>
            <div className="fm-why-item">
              <h4>35+ Years of Lab Expertise</h4>
              <p>Founded in 1988, we've helped hundreds of facilities managers renovate labs successfully.</p>
            </div>
            <div className="fm-why-item">
              <h4>Single Point of Contact</h4>
              <p>One partner for planning, equipment, installation, and ongoing support.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Trust Section */}
      <section className="fm-trust-section">
        <div className="container">
          <TrustBadges />
        </div>
      </section>

      {/* CTA Section */}
      <section className="fm-cta-section">
        <div className="container">
          <div className="fm-cta-content">
            <h2 className="fm-cta-title">Ready to Renovate Your Lab the Right Way?</h2>
            <p className="fm-cta-text">
              Book a free consultation to discuss your renovation. We'll assess your needs, 
              outline how we can help with safety, efficiency, and cost reduction—and provide 
              a clear path forward.
            </p>
            <HeroCTA text="Schedule Your Free Consultation" variant="primary" />
          </div>
        </div>
      </section>
    </div>
  )
}

export default FacilitiesManagersLandingPage
